import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-extraneous-dependencies
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import ReactDOM from 'react-dom';
import { GrClose } from 'react-icons/gr';
import { twMerge } from 'tailwind-merge';
import { getTestSelector } from '../../utilities/tests';
// import useModalStore from '../../stores/globalModalStore';
import Button from '../FormControls/Button';
import ButtonWithLoading from '../FormControls/ButtonWithLoading';
var Header = function (_a) {
    var title = _a.title, onClose = _a.onClose, _b = _a.showClose, showClose = _b === void 0 ? true : _b;
    var toggleOpen = React.useContext(ModalContext).toggleOpen;
    return (_jsxs("div", { className: "relative flex items-center p-3 pb-3 shadow-md", children: [_jsx("h2", { "data-cy": "modal-title", className: "text-xl font-light tracking-wide", children: title }), showClose && (_jsx(GrClose, { className: "ml-auto text-xl cursor-pointer", onClick: onClose || toggleOpen, title: "close modal icon", "data-cy": "close-modal" }))] }));
};
var Content = function (_a) {
    var children = _a.children, _b = _a.disableScrolling, disableScrolling = _b === void 0 ? false : _b, _c = _a.forceMaxHeight, forceMaxHeight = _c === void 0 ? true : _c, className = _a.className;
    var context = React.useContext(ModalContext);
    return (_jsx("div", { className: twMerge('px-5 py-4', !disableScrolling && 'overflow-y-auto', forceMaxHeight && 'max-h-screen-40', className), children: typeof children === 'function' ? children(context) : children }));
};
var Buttons = function (_a) {
    var children = _a.children, className = _a.className, buttons = _a.buttons;
    var toggleOpen = React.useContext(ModalContext).toggleOpen;
    return (_jsx("div", { className: clsx('flex rounded-b-xl items-center px-3 pb-3', className), children: buttons
            ? buttons.map(function (button, index) {
                return button.useLoading ? (_jsx(ButtonWithLoading, { buttonStyle: button.style, buttonColor: button.color, className: button.className, onClick: function () {
                        if (button.onClick) {
                            button.onClick();
                        }
                        if (button.closeAfterClick) {
                            toggleOpen();
                        }
                    }, loading: button.loading, disabled: button.disabled, testSelector: button.testSelector, children: button.label }, index)) : (_jsx(Button, { buttonStyle: button.style, buttonColor: button.color, className: button.className, disabled: button.disabled, onClick: function () {
                        if (button.onClick) {
                            button.onClick();
                        }
                        if (button.closeAfterClick) {
                            toggleOpen();
                        }
                    }, testSelector: button.testSelector, children: button.label }, index));
            })
            : typeof children === 'function'
                ? children(toggleOpen)
                : children }));
};
var ModalContext = React.createContext({
    open: false,
    toggleOpen: function () { },
});
var getMinWidth = function (size) {
    switch (size) {
        case 'small':
            return 'sm:min-w-sm';
        case 'medium':
            return 'sm:min-w-sm md:min-w-md';
        case 'large':
            return 'sm:min-w-sm md:min-w-md lg:min-w-lg';
        case 'full':
        default:
            return 'h-[calc(100vh-80px)] w-screen m-4 sm:m-10';
    }
};
var getMaxWidth = function (size) { return (size === 'small' ? 'max-w-xs' : ''); };
var Modal = function (_a) {
    var triggerElement = _a.triggerElement, show = _a.show, toggleOverride = _a.toggleOverride, children = _a.children, _b = _a.size, size = _b === void 0 ? 'auto' : _b, _c = _a.maxSize, maxSize = _c === void 0 ? 'auto' : _c, _d = _a.testSelector, testSelector = _d === void 0 ? getTestSelector('not-identified', 'modal') : _d, useTransparentContentContainer = _a.useTransparentContentContainer, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dataPublic = _a.dataPublic;
    var _e = useState(show === undefined ? false : show), open = _e[0], setOpen = _e[1];
    var contextValue = {
        open: open,
        toggleOpen: function () {
            if (toggleOverride) {
                toggleOverride();
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                setOpen(function (open) { return !open; });
            }
        },
    };
    useEffect(function () {
        if (!triggerElement && show !== undefined) {
            setOpen(show);
        }
    }, [show]);
    return (_jsxs(_Fragment, { children: [triggerElement &&
                React.cloneElement(triggerElement, {
                    onClick: contextValue.toggleOpen,
                }), ReactDOM.createPortal(_jsx(Transition, { onClick: function (e) { return e.stopPropagation(); }, "data-testid": "modal-container", show: open, className: "absolute top-0 left-0 z-50 flex items-center justify-center w-screen h-screen overflow-hidden transition-all duration-300 bg-black bg-opacity-60", enterFrom: "opacity-0", enterTo: "opacity-100", leaveFrom: "opacity-100", leaveTo: "opacity-0 pointer-events-none", children: _jsx(Transition.Child, { className: twMerge('bg-white rounded-xl transition-transform duration-300 flex flex-col max-h-[calc(100vh-20px)]', size !== 'auto' && getMinWidth(size), size !== 'full' && 'max-w-2xl', getMaxWidth(maxSize), !useTransparentContentContainer ? 'shadow-xl' : 'bg-opacity-0'), enterFrom: "scale-75", enterTo: "scale-100", leaveFrom: "scale-100", leaveTo: "scale-75", "data-cy": testSelector, children: _jsx(ModalContext.Provider, { value: contextValue, children: children }) }) }), document.querySelector('#modal-portal-container'))] }));
};
Modal.Header = Header;
Modal.Content = Content;
Modal.Buttons = Buttons;
// TODO: Bring this over when we need global modal functionality
// eslint-disable-next-line @typescript-eslint/no-unused-vars
Modal.openModal = function (id, data) { };
export { Modal as default };
